import { render } from "./MazeMaker.vue?vue&type=template&id=13b4f0d0&scoped=true"
import script from "./MazeMaker.vue?vue&type=script&lang=js"
export * from "./MazeMaker.vue?vue&type=script&lang=js"

import "./MazeMaker.vue?vue&type=style&index=0&id=13b4f0d0&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13b4f0d0"]])

export default __exports__